import { HttpMethod } from '../../components/Common/useFetch';
import { RequestOptions } from '../../components/Common/useRequest';
import useUserOrKaEmployeeRequest from '../../components/Common/useUserOrEmployeeRequest';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface UpdateFieldAlyticsItem {
  id: string;
  productIds: string[];
}

const useUpdateFieldAlyticsItems = (options?: RequestOptions) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrKaEmployeeRequest<UpdateFieldAlyticsItem[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/items`, method: HttpMethod.POST },
    options
  );
}

export default useUpdateFieldAlyticsItems;
